import React from 'react';
import Grid from '@material-ui/core/Grid';
import BankSelector from './components/GenericBankSelectorField';
import FormCurrencyField from './components/GenericFormCurrencyField';
import FormDatePicker from './components/GenericFormDatePicker';
import FormRadioGroup from './components/GenericFormRadioGroup';
import FormSelect from './components/GenericFormSelect';
import FormCheckbox from './components/GenericFormCheckbox';
import FormMaskedInput from './components/GenericMaskedInputField';
import FormTextField from './components/GenericFormTextField';
import FormAutocompleteField from './components/GenericAutocompleteField';
import { IGenericForm, GenericFormItem } from './interfaces';
import { cyrb53Hash } from 'utils/helpers';

// eslint-disable-next-line max-lines-per-function
const GenericForm: React.FC<IGenericForm> = ({
  fields,
  values,
  screenFields,
  changeField,
  setFieldValue,
  errors,
}) => {
  const renderProperlyField = (item: GenericFormItem) => {
    if (item.isRadioGroup) {
      return (
        <FormRadioGroup
          fields={fields}
          item={item}
          changeField={changeField}
          setFieldValue={setFieldValue}
          errors={errors}
          values={values}
        />
      );
    }

    if (item.isSelect) {
      return (
        <FormSelect
          fields={fields}
          item={item}
          changeField={changeField}
          setFieldValue={setFieldValue}
          errors={errors}
          values={values}
        />
      );
    }

    if (item.isDate) {
      return (
        <FormDatePicker
          fields={fields}
          item={item}
          changeField={changeField}
          setFieldValue={setFieldValue}
          errors={errors}
          values={values}
        />
      );
    }

    if (item.isMoney) {
      return (
        <FormCurrencyField
          fields={fields}
          item={item}
          changeField={changeField}
          setFieldValue={setFieldValue}
          errors={errors}
          values={values}
        />
      );
    }

    if (item.isCheckbox) {
      return (
        <FormCheckbox
          fields={fields}
          item={item}
          changeField={changeField}
          setFieldValue={setFieldValue}
          errors={errors}
          values={values}
        />
      );
    }

    if (item.mask) {
      return (
        <FormMaskedInput
          fields={fields}
          item={item}
          changeField={changeField}
          setFieldValue={setFieldValue}
          errors={errors}
          values={values}
        />
      );
    }

    if (item.bankSelector) {
      return (
        <BankSelector
          fields={fields}
          item={item}
          changeField={changeField}
          setFieldValue={setFieldValue}
          errors={errors}
          values={values}
        />
      );
    }

    if (item.isAutocomplete) {
      return (
        <FormAutocompleteField
          fields={fields}
          item={item}
          changeField={changeField}
          setFieldValue={setFieldValue}
          errors={errors}
          values={values}
        />
      );
    }

    return (
      <FormTextField
        fields={fields}
        item={item}
        changeField={changeField}
        setFieldValue={setFieldValue}
        errors={errors}
        values={values}
      />
    );
  };

  const renderFields = screenFields?.map(field => (
    <Grid
      key={cyrb53Hash(field.label)}
      item
      xs={field.gridXs}
      md={field.gridMd || field.gridXs}
      lg={field.gridLg || field.gridMd}
    >
      {renderProperlyField(field)}
    </Grid>
  ));

  return <React.Fragment>{renderFields}</React.Fragment>;
};

export default GenericForm;
